import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { createStyles, withStyles } from '@material-ui/core/styles'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import Typography from '@material-ui/core/Typography'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import Input from '@material-ui/core/Input'
import Collapse from '@material-ui/core/Collapse'
import ExpandLess from '@material-ui/icons/ExpandLess'
import ExpandMore from '@material-ui/icons/ExpandMore'
import Button from '@material-ui/core/Button'
import { getTanks, getGeoFencingZones } from 'http/tank'
import { transformTank, getGeoInfo } from 'utils/common'
import { setLoader } from 'utils/loader'
import { Error, ITank, Role } from 'types'
import Grid from '@material-ui/core/Grid';
import Checkbox from '@material-ui/core/Checkbox';

import {
  changeCountry,
  changeZone,
  changeStatus,
  changeProduct,
  changeType,
  changeShipTo,
  changeTankId,
  changeGeoZones,
  changeCustomer,
  updateOriginalResult,
  updateFilteredResult,
} from './actions'
import { COUNTRIES, ZONES, STATUS, PRODUCTS, TYPES, GEOZONES } from 'utils/constants'

const styles = createStyles(theme => ({
  root: {
    width: '100%',
    maxWidth: 600,
  },
  formControl: {
    width: '100%',
  },
  nested: {
    paddingLeft: theme.spacing.unit * 3,
  },
}))

interface IProps {
  classes: any
  role: Role
  tanks: {
    tanks: ITank[]
    geos: any
  }
  userCountry: string
  userZone: string
  countryFilter: any
  stateFilter: any
  country: string
  zone: any
  status: any
  product: any
  type: any
  sh: string
  tankId: string
  customer: string
  original: any
  geoZone: any
  changeCountry: (country: string) => void
  changeZone: (zone: string) => void
  changeStatus: (status: string) => void
  changeProduct: (product: string) => void
  changeType: (type: string) => void
  changeShipTo: (zone: string) => void
  changeTankId: (tankId: string) => void
  changeGeoZones: (geoZone: string) => void
  changeCustomer: (customer: string) => void
  updateOriginalResult: (tanks: any, geos: any, error: Error) => void
  updateFilteredResult: (tanks: any, geos: any) => void

}

interface IState {
  searchExpanded: boolean
  filterExpanded: boolean
  selectableZones: any
  filterCounries: any
  filterStates: any
  typeName: string[]
  productName: string[]
  geoZoneNames: any
  displayZone: boolean
  geoFencingZones: any,
  selectedGeoLocations: string
}

class Filter extends React.PureComponent<IProps, IState> {
  state = {
    searchExpanded: false,
    filterExpanded: false,
    selectableZones: [],
    filterCounries: [],
    filterStates: [],
    stateName: [],
    typeName: [],
    productName: [],
    statusName: [],
    geoZoneNames: [],
    displayZone: false,
    geoFencingZones: [],
    selectedGeoLocations: ''
  }

  isAdmin = this.props.role === Role.ADMIN || this.props.role === Role.CLT
  isAdminCLTCustomer = this.props.role === Role.ADMIN || this.props.role === Role.CLT || this.props.role === Role.CUSTOMER

  componentDidMount() {
    const { country, zone, changeCountry, changeZone, role, countryFilter, stateFilter } = this.props
    var filterCountry
    if (countryFilter != undefined) {
      filterCountry = COUNTRIES.filter((country => countryFilter.includes(country.key)))
      this.setState({
        ...this.state,
        filterCounries: filterCountry
      })
    }

    //filter state
    var filterState
    if (stateFilter !== undefined) {
      filterState = ZONES.filter((zone => stateFilter.includes(zone.key)))
      this.setState({
        filterStates: filterState
      })
    }
    if (role == Role.ADMIN || role == Role.CLT || role == Role.CUSTOMER) {
      if (country) {
        const newCountry = country
        changeCountry(newCountry);
        var zonesForCountry;
        if (filterState !== undefined && filterState !== '') {
          zonesForCountry = filterState.filter((zone => zone.country == newCountry))
        }
        else {
          zonesForCountry = ZONES.filter((zone => zone.country == newCountry))
        }
        this.setState({
          ...this.state,
          selectableZones: zonesForCountry,
          filterCounries: filterCountry
        })
        changeZone(zone);
      }
    }
    else {
      this.searchTanks();
    }
  }

  searchTanks = async () => {
    const { updateOriginalResult, country, zone, status, product, type, geoZone } = this.props
    var stateString = '';
    if (zone != undefined && zone.length > 0) {
      for (var i = 0; i < zone.length; i++) {
        if (i == 0) {
          stateString = zone[i];
        }
        else {
          stateString = stateString + ',' + zone[i]
        }
      }
    }

    var statusString = '';
    if (status != undefined && status.length > 0) {
      for (var i = 0; i < status.length; i++) {
        if (i == 0) {
          statusString = status[i];
        }
        else {
          statusString = statusString + ',' + status[i]
        }
      }
    }

    var typeString = '';
    if (type != undefined && type.length > 0) {
      for (var i = 0; i < type.length; i++) {
        if (i == 0) {
          typeString = type[i];
        }
        else {
          typeString = typeString + ',' + type[i]
        }
      }
    }

    var productString = '';
    if (product != undefined && product.length > 0) {
      for (var i = 0; i < product.length; i++) {
        if (i == 0) {
          productString = product[i];
        }
        else {
          productString = productString + ',' + product[i]
        }
      }
    }

    let error = Error.NONE
    let tanks = []
    let geos = []

    try {
      setLoader(true)
      const { messageStatus, messageCode, data } = await getTanks(country, stateString, statusString, productString, typeString);
      var geoFenceData;
      var dataGeoFencingZones = await getGeoFencingZones()
      geoFenceData = dataGeoFencingZones.data.Items;
      this.setState({
        ...this.state,
        geoFencingZones: geoFenceData
      })

      if (messageStatus === 'error') {
        error = messageCode
      } else {
        tanks = Object.values(data).map(transformTank)
        tanks.sort((tankA, tankB) => tankB.info.value - tankA.info.value)
        geos = tanks.map(getGeoInfo).filter(geo => geo)
        tanks = tanks.reduce((acc, tank) => {
          acc[tank.deviceID] = tank
          return acc
        }, {})

        localStorage.setItem('order', 'asc');
        localStorage.setItem('orderBy', 'level');
      }
    } catch (err) {
      console.log(err)
      error = err.message
    }
    updateOriginalResult(tanks, geos, error)
    setTimeout(this.filterTanks, 0)
    setLoader(false)
  }

  handleSearchClick = () =>
    this.setState({
      ...this.state,
      searchExpanded: !this.state.searchExpanded,
    })

  handleCountryChange = async (event: any) => {
    const newCountry = event.target.value
    const { country, changeCountry, zone } = this.props
    if (newCountry !== country) {
      changeCountry(newCountry)
      var zonesForCountry;
      if (this.state.filterStates.length == 0) {
        zonesForCountry = ZONES.filter((zone => zone.country == newCountry))
      }
      else {
        zonesForCountry = this.state.filterStates.filter((zone => zone.country == newCountry))
      }
      this.setState({
        ...this.state,
        selectableZones: zonesForCountry
      })
    }
  }

  handleZoneChange = async (event: any) => {
    const newZone = event.target.value
    const { zone, changeZone } = this.props
    if (newZone !== zone) {
      changeZone(newZone)
    }
  }

  handleStatusChange = async (event: any) => {
    const newStatus = event.target.value
    const { status, changeStatus } = this.props
    if (newStatus !== status) {
      changeStatus(newStatus)
    }
  }

  handleProductChange = async (event: any) => {
    const { changeProduct } = this.props
    const {
      target: { value },
    } = event;

    const newProduct = value === 'string' ? value.split(',') : value;
    this.setState({
      ...this.state,
      productName: newProduct,
    })
    changeProduct(newProduct);
  }

  handleTypeChange = async (event: any) => {
    const { type, changeType } = this.props
    const {
      target: { value },
    } = event;

    const newType = value === 'string' ? value.split(',') : value;
    this.setState({
      ...this.state,
      typeName: newType,
    })
    changeType(newType);
  }

  handleGeoZoneChange = async (event: any) => {
    const { changeGeoZones } = this.props
    const {
      target: { value },
    } = event;

    const newGeoZone = value === 'string' ? value.split(',') : value;
    this.setState({
      ...this.state,
      geoZoneNames: newGeoZone,
    })

    changeGeoZones(newGeoZone);

    setTimeout(this.filterTanks, 0)

  }
  handleFilterClick = () =>
    this.setState({
      ...this.state,
      filterExpanded: !this.state.filterExpanded,
    })

  handleShipToChange = async (event: any) => {
    const newSh = event.target.value
    const { sh, changeShipTo } = this.props

    if (newSh !== sh) {
      changeShipTo(newSh.toLowerCase())
      setTimeout(this.filterTanks, 0)
    }
  }

  handleTankIdChange = async (event: any) => {
    const newTankId = event.target.value
    const { tankId, changeTankId } = this.props

    if (newTankId !== tankId) {
      changeTankId(newTankId.toLowerCase())
      setTimeout(this.filterTanks, 0)
    }
  }
  //Customer search
  handleCustomerChange = async (event: any) => {
    const newCustomer = event.target.value
    const { customer, changeCustomer } = this.props
    if (newCustomer !== customer) {
      changeCustomer(newCustomer.toLowerCase())
      setTimeout(this.filterTanks, 0)
    }
  }

  filterTanks = () => {
    const { original, sh, tankId, customer, updateFilteredResult } = this.props
    if (customer !== undefined && (customer.toUpperCase().includes('BHP') || customer.toUpperCase().includes('ALCOA'))) {
      this.setState({
        ...this.state,
        displayZone: true
      })
    }
    else {
      this.setState({
        ...this.state,
        displayZone: false
      })

    }
    let tanks = original.tanks
    tanks = Object.values(tanks).filter((tank: ITank) => {
      if (sh) {
        if (!tank.sh) return false
        if (tank.sh.toLowerCase().indexOf(sh) === -1) return false
      }

      if (tankId) {
        if (!tank.tankId) return false
        if (tank.tankId.toLowerCase().indexOf(tankId) === -1) return false
      }

      if (customer) {
        if (!tank.name) return false
        if (tank.name.toLowerCase().indexOf(customer) === -1) return false
      }
      return true
    })

    const geos = tanks.map(getGeoInfo).filter(geo => geo)
    tanks = tanks.reduce((acc, tank) => {
      acc[tank.deviceID] = tank
      return acc
    }, {})
    updateFilteredResult(tanks, geos)
  }

  render() {
    const { country, zone, status, product, type, sh, tankId, geoZone, customer, classes } = this.props
    var loggedInUser = localStorage.getItem('username')
    if (loggedInUser !== null && (loggedInUser.toUpperCase().includes('BHP') || loggedInUser.toUpperCase().includes('ALCOA'))) {
      this.setState({
        ...this.state,
        displayZone: true
      })
    }
    // if (geoZone !== '') {
    //   this.setState({
    //     ...this.state,
    //     displayZone: true
    //   })
    // }
    var stateName = [];
    if (zone === '' || zone === undefined) {
      stateName = this.state.stateName
    }
    else {
      stateName = zone === 'string' ? zone.split(',') : zone;
    }

    var statusName = [];
    if (status === '' || status === undefined) {
      statusName = this.state.statusName
    }
    else {
      statusName = status === 'string' ? status.split(',') : status;
    }

    var typeName = [];
    if (type === '' || type === undefined) {
      typeName = this.state.typeName
    }
    else {
      typeName = type === 'string' ? type.split(',') : type;
    }

    var productName = [];
    if (product === '' || product === undefined) {
      productName = this.state.productName
    }
    else {
      productName = product === 'string' ? product.split(',') : product;
    }
    var geoZoneNames = [];
    if (geoZone === '' || geoZone === undefined) {
      geoZoneNames = this.state.geoZoneNames
    }
    else {
      geoZoneNames = geoZone === 'string' ? geoZone.split(',') : geoZone;
    }
    localStorage.setItem('geoFencingZonesStorage', JSON.stringify(this.state.geoFencingZones));

    const { searchExpanded, filterExpanded } = this.state
    return (
      <List className={classes.root}>
        {this.isAdminCLTCustomer && (
          <Fragment>
            <ListItem button onClick={this.handleSearchClick}>
              <ListItemText primary="Filter" />
              {searchExpanded ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={searchExpanded} timeout="auto" unmountOnExit>
              <Grid container direction="row" spacing={10}>
                <Grid item style={{ width: '300px' }}>
                  <List disablePadding>
                    <ListItem button className={classes.nested}>
                      <FormControl className={classes.formControl}>
                        <InputLabel htmlFor="country">Country</InputLabel>
                        <Select
                          value={country}
                          onChange={this.handleCountryChange}
                          input={<Input name="country" id="country" />}
                        >
                          <MenuItem value="">
                            <Typography variant="body1" />
                          </MenuItem>
                          {(this.state.filterCounries !== undefined && this.state.filterCounries.length > 0) ? (this.state.filterCounries.map(({ key, label }) =>
                          (<MenuItem key={key} value={key}>
                            <Typography variant="body1">{label}</Typography>
                          </MenuItem>))) :
                            (COUNTRIES.map(({ key, label }) =>
                            (<MenuItem key={key} value={key}>
                              <Typography variant="body1">{label}</Typography>
                            </MenuItem>)))
                          }
                        </Select>
                      </FormControl>
                    </ListItem>
                  </List>
                  <List>
                    <ListItem button className={classes.nested}>
                      <FormControl className={classes.formControl}>
                        <InputLabel htmlFor="state">State</InputLabel>
                        <Select
                          multiple
                          value={stateName}
                          onChange={this.handleZoneChange}
                          input={<Input name="state" id="state" />}
                          renderValue={(selected: any) => selected.join(', ')}
                        >
                          <MenuItem value="">
                            <Typography variant="body1" />
                          </MenuItem>
                          {this.state.selectableZones.map(({ key, label }) => (
                            <MenuItem key={key} value={key}>
                              <Checkbox checked={stateName.indexOf(key) > -1} />
                              <ListItemText primary={label} />
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </ListItem>
                  </List>
                  {this.isAdmin && (<ListItem button className={classes.nested}>
                    <FormControl className={classes.formControl}>
                      <InputLabel htmlFor="status">Status</InputLabel>
                      <Select
                        multiple
                        value={statusName}
                        onChange={this.handleStatusChange}
                        input={<Input name="status" id="status" />}
                        renderValue={(selected: any) => selected.join(', ')}
                      >
                        <MenuItem value="">
                          <Typography variant="body1" />
                        </MenuItem>
                        {STATUS.map(({ key, label }) => (
                          <MenuItem key={key} value={key}>
                            <Checkbox checked={statusName.indexOf(key) > -1} />
                            <ListItemText primary={label} />
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </ListItem>)}
                </Grid>
                <Grid item style={{ width: '300px' }}>
                  <ListItem button className={classes.nested}>
                    <FormControl className={classes.formControl}>
                      <InputLabel htmlFor="product">Product</InputLabel>
                      <Select
                        multiple
                        value={productName}
                        onChange={this.handleProductChange}
                        input={<Input name="product" id="product" />}
                        renderValue={(selected: any) => selected.join(', ')}
                      >
                        <MenuItem value="">
                          <Typography variant="body1" />
                        </MenuItem>
                        {PRODUCTS.map(({ key, label }) => (
                          <MenuItem key={key} value={key}>
                            <Checkbox checked={productName.indexOf(key) > -1} />
                            <ListItemText primary={label} />
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </ListItem>
                  <ListItem button className={classes.nested}>
                    <FormControl className={classes.formControl}>
                      <InputLabel htmlFor="type">Type</InputLabel>
                      <Select
                        multiple
                        value={typeName}
                        onChange={this.handleTypeChange}
                        input={<Input name="type" id="type" />}
                        renderValue={(selected: any) => selected.join(', ')}
                      >
                        <MenuItem value="">
                          <Typography variant="body1" />
                        </MenuItem>
                        {TYPES.map(({ key, label }) => (
                          <MenuItem key={key} value={key}>
                            <Checkbox checked={typeName.indexOf(key) > -1} />
                            <ListItemText primary={label} />
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </ListItem>
                </Grid>
              </Grid>
              <ListItem button className={classes.nested}>
                <Button fullWidth variant="contained" onClick={this.searchTanks}>
                  <Typography variant="h4" color="primary">
                    Filter
                  </Typography>
                </Button>
              </ListItem>
            </Collapse>
          </Fragment>
        )}
        <ListItem button onClick={this.handleFilterClick}>
          <ListItemText primary="Search" />
          {filterExpanded ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
        <Collapse in={filterExpanded} timeout="auto" unmountOnExit>
          <List disablePadding>
            <ListItem button className={classes.nested}>
              <FormControl className={classes.formControl}>
                <InputLabel htmlFor="state">Ship To</InputLabel>
                <Input value={sh} onChange={this.handleShipToChange} />
              </FormControl>
            </ListItem>
            <ListItem button className={classes.nested}>
              <FormControl className={classes.formControl}>
                <InputLabel htmlFor="state">Tank ID</InputLabel>
                <Input value={tankId} onChange={this.handleTankIdChange} />
              </FormControl>
            </ListItem>
            <ListItem button className={classes.nested}>
              <FormControl className={classes.formControl}>
                <InputLabel htmlFor="state">Customer</InputLabel>
                <Input value={customer} onChange={this.handleCustomerChange} />
              </FormControl>
            </ListItem>
          </List>
        </Collapse>
        {this.state.displayZone !== undefined && this.state.displayZone && (
          <Grid>
            <Grid item style={{ width: '300px' }}>
              <ListItem button className={classes.nested}>
                <FormControl className={classes.formControl}>
                  <InputLabel htmlFor="geoZone">Zone</InputLabel>
                  <Select
                    multiple
                    value={geoZoneNames}
                    onChange={this.handleGeoZoneChange}
                    input={<Input name="geoZone" id="geoZone" />}
                    renderValue={(selected: any) => selected.join(', ')}
                  >
                    <MenuItem value="">
                      <Typography variant="body1" />
                    </MenuItem>
                    {this.state.geoFencingZones.map(({ zonename, customerName }) => (
                      (customerName.toUpperCase() == customer.toUpperCase() && (<MenuItem key={zonename} value={zonename}>
                        <Checkbox checked={geoZoneNames.indexOf(zonename) > -1} />
                        <ListItemText primary={zonename} />
                      </MenuItem>)
                      )))}
                  </Select>
                </FormControl>
              </ListItem>
            </Grid>
          </Grid>
        )
        }
      </List>
    )
  }
}

const mapStateToProps = ({ filter: { country, zone, status, product, type, geoZone, sh, tankId, customer, original } }) => ({
  original,
  country,
  zone,
  status,
  product,
  type,
  geoZone,
  sh,
  tankId,
  customer,
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      changeCountry,
      changeZone,
      changeStatus,
      changeProduct,
      changeType,
      changeGeoZones,
      changeShipTo,
      changeTankId,
      changeCustomer,
      updateOriginalResult,
      updateFilteredResult,
    },
    dispatch,
  )

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(Filter))
